import {exportColourPaletteColours} from "../../../apiCalls/apiCalls";
import {writeToFile} from "../../../helpers/writeToFile";
import {IconButton} from "@mui/material";
import {DownloadForOfflineRounded} from "@mui/icons-material";
import {FONT_SIZE_SMALL} from "../../../providers/designSystem";

export const ExportColourPaletteColoursButton = ({colourPalette}) =>
{
    const handleClick = async () => {
        try {
            const data = await exportColourPaletteColours(colourPalette.id);
            writeToFile(data, colourPalette.name);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <IconButton onClick={() => handleClick()} sx={{ justifySelf: 'end', alignSelf: 'center' }}>
            <DownloadForOfflineRounded sx={{fontSize: `${FONT_SIZE_SMALL}`}}/>
        </IconButton>
    );
}